<template>
  <div class="container">
    <div class="handle-box">
      <el-form ref="queryCondition" :model="queryCondition" label-width="100px" class="searchForm">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="8位码" prop="eightBitCode">
                  <el-input class="handle-input" v-model="queryCondition.eightBitCode" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="DC" prop="tmDcId">
                  <ic-select clearable table="BASE" class="handle-input" field="DC" v-model="queryCondition.tmDcId" filterable style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="提货点" prop="tmPickupId">
                  <ic-select clearable table="BASE" class="handle-input" field="PICKUP_POINT" v-model="queryCondition.tmPickupId" filterable style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="8位码名称" prop="eightBitCodeName">
                  <el-input class="handle-input" v-model="queryCondition.eightBitCodeName" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-collapse-transition>
            <el-col :span="24" v-if="isShow">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="温区" prop="temperature">
                    <ic-select clearable :allValues="true" table="COMMON" class="handle-input" field="TEMPERATURE" v-model="queryCondition.temperature" style="width:100%"></ic-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="运输方式" prop="transportaionMethod">
                    <ic-select clearable :allValues="true" table="COMMON" class="handle-input" field="TRANSPORTAION_METHOD" v-model="queryCondition.transportaionMethod" style="width:100%"></ic-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-collapse-transition>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" @click="queryData(1)" type="primary">{{$t("common.search")}}</el-button>
          <el-button size="mini" @click="restQueryForm()" type="primary">{{$t("common.reset")}}</el-button>
          <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
        </el-row>
      </el-form>
    </div>
    <el-row class="action-btn-row">
      <el-button size="mini" class="btn" @click="createQuotationApply" v-acl="Todo-listCreateQuotationApply" type="primary">创建产品报价申请单</el-button>
    </el-row>
    <el-table ref="table" row-key="ttTodoListId" :data="tableData" border highlight-current-row max-height='400'>
      <el-table-column fixed min-width="56" type="selection" :reserve-selection="true"></el-table-column>
      <el-table-column show-overflow-tooltip fixed min-width="70" prop="eightBitCode" label="8位码"></el-table-column>
      <el-table-column show-overflow-tooltip prop="eightBitCodeName" label="8位码名称"></el-table-column>
      <el-table-column show-overflow-tooltip prop="tmPickupId" min-width="75" label="提货点">
        <template slot-scope="scope">{{scope.row.tmPickupId | ic('BASE','PICKUP_POINT')}}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="tmDcId" label="DC">
        <template slot-scope="scope">{{scope.row.tmDcId | ic('BASE','DC')}}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="temperature" min-width="75" label="温区">
        <template slot-scope="scope">{{scope.row.temperature | ic('COMMON','TEMPERATURE')}}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="transportaionMethod | ic('COMMON','TRANSPORTAION_METHOD')" min-width="100" label="运输方式">
        <template slot-scope="scope">{{scope.row.transportaionMethod | ic('COMMON','TRANSPORTAION_METHOD')}}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="freight" label="8位码运费"></el-table-column>
      <el-table-column show-overflow-tooltip prop="tmSupplierId" label="线路供应商"><template slot-scope="scope">{{scope.row.tmSupplierId|ic("BASE","CARRIER")}}</template></el-table-column>
      <el-table-column show-overflow-tooltip prop="source" label="来源"><template slot-scope="scope">{{scope.row.source |ic('TT_TODO_LIST','SOURCE')}}</template></el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination :page-sizes="[10,15,50,100]" :currentPage="queryCondition.pageNum" :pageSize="queryCondition.pageSize" @size-change="pageSizeChange" @current-change="pageNumberChange" layout="total, sizes, prev, pager, next, jumper" :total="queryCondition.total"></el-pagination>
    </div>
  </div>
</template>

<script>
import dataTableUtils from "@/utils/dataTableUtils";
import todoListApi from "@/api/quotation-apply/todoList";
import IcSelect from "@/components/common/icSelect";
import utils from "@/utils/commonFun";
import { Message } from "element-ui";

export default {
  name: "todoList",
  components: { IcSelect },
  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      tableData: [],
      queryCondition: {
        eightBitCode: '',
        tmDcId: '',
        tmPickupId: '',
        eightBitCodeName: '',
        temperature: '',
        transportaionMethod: '',
        pageSize: 15,
        pageNum: 1,
        total: 0
      },
    }
  },
  computed: {
    selection() {
      return this.$refs.table.selection;
    }
  },
  created: function () {
    this.queryData(1);
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      todoListApi.list(this.queryCondition).then(resp => {
        this.tableData = resp.data.records;
        this.queryCondition.pageNum = resp.data.current;
        this.queryCondition.pageSize = resp.data.size;
        this.queryCondition.total = resp.data.total;
      })
    },
    restQueryForm() {
      this.$refs.queryCondition.resetFields();
      this.queryCondition = {
        eightBitCode: '',
        tmDcId: '',
        tmPickupId: '',
        eightBitCodeName: '',
        temperature: '',
        transportaionMethod: '',
        pageSize: 15,
        pageNum: 1,
        total: 0
      }
      this.$refs.table.clearSelection();
      this.queryData(1);
    },
    createQuotationApply() {
      let selction = this.selection;
      let that = this;
      if (!utils.isEmpty(selction)) {
        let ids = selction.map(row => row.ttTodoListId).join(",");
        todoListApi.createQuotationApply({ ids: ids }).then(resp => {
          if (resp.code = 200) {
            Message.success(that.$t("quote.todoList.createQuotationApplySuccess"));
            that.queryData(1);
          } else {
            Message.error(resp.msg);
          }
        });
      } else {
        Message.error(this.$t("common.pleaseSelectData"));
      }
    }
  },
  extends: dataTableUtils
}
</script>

<style scoped>
.table {
  margin-top: 10px;
}
</style>
